export default "__VITE_ASSET__D4n8KJN4__"